export const VSCODE_EXTENSION_DEEPLINK = "vscode://Bugzi.Bugzi/";
export const VSCODE_MARKETPLACE_URL =
  "https://marketplace.visualstudio.com/items?itemName=Bugzi.Bugzi";

/**
 * Attempts to open the VS Code extension deep link.
 * If the browser window does not lose focus within FALLBACK_TIMEOUT_MS,
 * it means VS Code did not launch (likely not installed / protocol not handled),
 * so we redirect to the Marketplace web page as a fallback.
 */
export const openVsCodeExtension = () => {
  const FALLBACK_TIMEOUT_MS = 2500;
  const windowBlurred = () => document.hasFocus() === false;

  window.open(VSCODE_EXTENSION_DEEPLINK, "_self");

  setTimeout(() => {
    if (!windowBlurred()) {
      window.location.href = VSCODE_MARKETPLACE_URL;
    }
  }, FALLBACK_TIMEOUT_MS);
};
